// The booking wizard's wording in Spanish; keys match en.ts.
import type { en } from "./en";

export const es = {
  // Page
  schedule_appointment: "Programar cita",
  powered_by: "Desarrollado por",

  // Patient type
  new_or_existing: "¿Eres paciente nuevo o existente?",
  new_patient: "Paciente nuevo",
  existing_patient: "Paciente existente",
  first_time_visiting: "Primera vez visitando esta oficina",
  been_here_before: "He estado aquí antes",

  // Appointment info
  what_type: "¿Qué tipo de cita estás programando?",
  no_types_available:
    "No hay tipos de citas disponibles para programación en línea en este momento.",
  minutes: "%{count} minutos",
  additional_info: "¿Qué problema o preocupación le gustaría que atendamos?",
  describe_concern: "Por favor describa su preocupación...",

  // Provider
  pick_provider: "Elige un proveedor",
  loading_providers: "Cargando proveedores...",
  failed_load_providers: "No se pudieron cargar los proveedores. Inténtelo de nuevo.",
  any_provider: "Cualquier proveedor",
  show_all_available: "Mostrar todos los horarios disponibles",
  no_availability: "Sin disponibilidad",

  // Time
  pick_a_time: "Elige un horario",
  finding_times: "Buscando horarios disponibles...",
  no_times_for_date: "No hay horarios disponibles para esta fecha",
  slot_just_taken: "Lo sentimos, ese horario acaba de ser reservado. Elige otro.",
  jump_to_next: "Ir a la próxima disponible",
  morning: "Mañana",
  afternoon: "Tarde",
  cant_find_time:
    "¿No encuentras un horario? Llama a nuestra oficina y te ayudaremos a encontrar uno.",

  // Patient info
  your_information: "Tu información",
  first_name: "Nombre",
  last_name: "Apellido",
  preferred_name: "Nombre preferido",
  optional: "Opcional",
  date_of_birth: "Fecha de nacimiento",
  phone_number: "Número de teléfono",
  required: "Requerido",
  invalid_phone: "Ingrese un número de teléfono válido de 10 dígitos",
  min_age: "El paciente debe tener al menos 5 años",
  future_date: "No puede ser una fecha futura",
  referral_question: "¿Cómo se enteró de nosotros?",
  referral_prompt: "Seleccione una opción",
  referral_detail_who: "¿Quién le refirió?",
  referral_detail_other: "Cuéntenos cómo se enteró de nosotros",
  referral_detail_optional: "Detalles adicionales (opcional)",
  verification_disclaimer: "Se enviará un código de verificación a este número.",
  phone_verified: "Teléfono verificado",
  verifying: "Verificando...",
  verify: "Verificar",
  invalid_code: "Código inválido. Por favor, inténtelo de nuevo.",
  sending: "Enviando...",
  resend_code: "Reenviar código",
  email: "Correo electrónico",
  send_verification: "Enviar código de verificación",
  sending_code: "Enviando código...",

  // Insurance
  insurance_info: "Información del seguro",
  have_insurance: "¿Tienes seguro médico?",
  insurance_changed: "¿Ha cambiado tu seguro desde tu última visita?",
  no_insurance_change: "Sin cambios",
  yes: "Sí",
  no: "No",
  insurance_name: "Nombre del seguro",
  subscriber_name: "Nombre del asegurado",
  subscriber_dob: "Fecha de nacimiento del asegurado",
  subscriber_id: "Número de identificación del asegurado",
  group_number: "Número de grupo",
  select_option: "Por favor seleccione una opción",
  card_photo_title: "Foto de su tarjeta de seguro",
  card_photo_hint:
    "Agregue fotos de ambos lados de su tarjeta para que podamos verificar su cobertura antes de su visita.",
  card_front: "Frente de la tarjeta",
  card_back: "Reverso de la tarjeta",
  add_photo: "Agregar foto",
  uploading_photo: "Subiendo foto...",
  remove_photo: "Quitar",
  card_upload_failed: "No pudimos agregar la foto. Puede intentarlo de nuevo o continuar sin ella.",
  card_try_again: "Intentar de nuevo",

  // Review
  review_appointment: "Revisa tu cita",
  appointment_details: "Detalles de la cita",
  type_label: "Tipo",
  provider: "Proveedor",
  any_available: "Cualquier disponible",
  date_and_time: "Fecha y hora",
  notes: "Notas",
  patient_information: "Información del paciente",
  name: "Nombre",
  phone: "Teléfono",
  insurance: "Seguro",
  subscriber: "Asegurado",
  subscriber_id_label: "ID del asegurado",
  group_hash: "# de grupo",
  no_insurance: "Sin seguro",
  card_photos: "Fotos de la tarjeta",
  card_front_short: "Frente",
  card_back_short: "Reverso",
  waitlist: "Contáctame si hay horarios disponibles más temprano",
  consent_prefix: "Al programar, aceptas nuestros ",
  terms: "Términos y Condiciones",
  consent_and: " y ",
  privacy: "Política de Privacidad",
  consent_suffix:
    ". Al proporcionar tu número de teléfono, aceptas recibir mensajes de texto. Pueden aplicar tarifas de mensajes y datos.",
  scheduling: "Programando...",
  schedule_appointment_btn: "Programar cita",
  continue_to_payment: "Continuar al pago",

  // Deposit
  deposit_title: "Pague su depósito",
  deposit_explainer:
    "Un depósito de %{amount} confirma esta cita. Se acreditará a su cuenta y se aplicará a su visita. Si no se presenta a su cita, perderá su depósito.",
  deposit_due: "Depósito",
  deposit_card_fee: "Cargo por tarjeta",
  deposit_card_fee_notice:
    "Los pagos con tarjeta de crédito incluyen un cargo por procesamiento del %{percentage}%. Las tarjetas de débito no tienen cargo.",
  deposit_total: "Total",
  deposit_loading: "Cargando pago seguro...",
  deposit_paying: "Procesando...",
  deposit_pay_and_book: "Pagar y reservar",
  deposit_card_error:
    "No pudimos procesar su depósito. Verifique los datos de su tarjeta e inténtelo de nuevo.",
  deposit_unavailable: "No se pudo cargar el pago seguro. Por favor llame a la oficina.",
  deposit_needs_hold: "No pudimos reservar este horario. Por favor elija un horario de nuevo.",
  deposit_processing:
    "Su pago aún se está confirmando. No pague de nuevo — la oficina confirmará su cita en breve.",

  // Confirmation
  appointment_requested: "¡Recibimos su solicitud de cita!",
  confirm_message:
    "El consultorio la revisará y le enviará una confirmación. Si necesitamos información adicional, nuestro equipo se pondrá en contacto contigo.",
  date: "Fecha",
  time: "Hora",
  add_to_google: "Agregar a Google Calendar",
  download_ics: "Descargar archivo de calendario (.ics)",
  questions_call: "¿Preguntas? Llámanos al",

  // Errors
  network_error: "Algo salió mal. Por favor, inténtelo de nuevo.",

  // Common
  back: "Atrás",
  continue: "Continuar",
  review: "Revisar",

  // Step labels
  step_appointment: "Cita",
  step_provider: "Proveedor",
  step_time: "Hora",
  step_your_info: "Tu info",
  step_insurance: "Seguro",
} as const satisfies Record<keyof typeof en, string>;
